import React from 'react';
import { Link } from 'react-router-dom';
import HealthCheck from '../common/HealthCheck';

export default function Footer() {
    return (
        <footer>
            <div className={'spectrum-thin'} />
            <div className={'brands flex'}>
                <div className={'content brand-banner flex'}>
                    <img className={'costcutter'} alt={'Costcutter'} src={'/brands/costcutter_logo.jpg'} />
                    <img className={'mace'} alt={'Mace'} src={'/brands/mace.png'} />
                    <img className={'simplyfresh'} alt={'Simply Fresh'} src={'/brands/simplyfresh.png'} />
                    <img className={'supershop'} alt={'Supershop'} src={'/brands/supershop.png'} />
                </div>
            </div>
            <div className={'lower-footer'}>
                <div className={'content site-info flex'}>
                    <div className={'footer-links'}>
                        <span className={'links-heading'}>Legal</span>
                        <p>
                            <a target={'_blank'} href={'https://activhub.costcutter.com/terms-of-use'}>
                                Terms & conditions
                            </a>
                        </p>
                        <p>
                            <a target={'_blank'} href={'https://activhub.costcutter.com/cookie-policy'}>
                                Cookie policy
                            </a>
                        </p>
                        <p>
                            <a target={'_blank'} href={'https://activhub.costcutter.com/privacy-policy'}>
                                Privacy policy
                            </a>
                        </p>
                    </div>
                    <div className={'footer-details'}>
                        <img
                            className={'cc-group'}
                            src={'/logos/costcutter_white.png'}
                            alt={'Costcutter Supermarkets Group'}
                        />
                        <br />
                        <p className={'tagline'}>Helping independent retailers thrive</p>
                        <p className={'copyright'}>
                            Company Registration: 2059678 VAT Registered: 84720662
                            <br />©{new Date().getFullYear()} Costcutter Supermarkets Group.
                        </p>
                    </div>
                </div>
            </div>
            <HealthCheck />
        </footer>
    );
}
